import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.neutral.cotton,
    flex: 1,
    paddingHorizontal: scale(16),
    paddingTop: scale(12),
  },
  mandatoryRow: {
    backgroundColor: colors.neutral.mist,
    borderRadius: scale(10),
    marginTop: scale(4),
    paddingHorizontal: scale(12),
  },
  mandatoryTextContainer: {
    flex: 1,
    marginRight: scale(12),
  },
  nativeSwitchContainer: {
    alignItems: 'center',
    height: scale(20),
    justifyContent: 'center',
    position: 'relative',
    width: scale(38),
  },
  nativeSwitchDisabledOverlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.38)',
    borderRadius: scale(999),
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: scale(40),
    paddingLeft: scale(12),
    paddingRight: scale(12),
  },
  section: {
    marginBottom: scale(14),
  },
  sectionTitle: {
    marginBottom: scale(4),
  },
  switchControl: {
    minWidth: scale(38),
  },
  switchLoaderContainer: {
    alignItems: 'center',
    height: scale(20),
    justifyContent: 'center',
    width: scale(38),
  },
  webSwitchTrack: {
    backgroundColor: colors.disabled.smoke,
    borderRadius: scale(999),
    height: scale(20),
    justifyContent: 'center',
    paddingHorizontal: scale(2),
    width: scale(38),
  },
  webSwitchTrackActive: {
    backgroundColor: colors.primary.carnation,
  },
  webSwitchTrackDisabled: {
    opacity: 0.7,
  },
  webSwitchThumb: {
    backgroundColor: colors.neutral.cotton,
    borderRadius: scale(999),
    height: scale(16),
    width: scale(16),
  },
  webSwitchThumbActive: {
    alignSelf: 'flex-end',
  },
  webSwitchThumbInactive: {
    alignSelf: 'flex-start',
  },
});

export default styles;
